import * as Yup from "yup";

const OrderSchema = Yup.object({
    buyer_company_name : Yup.string().required('Buyer Name is required!'),
    phone : Yup.number().required('Phone is required!').typeError('Enter a Valid Phone number'),
    email : Yup.string().email().required('Email is required'),
    is_order_in_sez : Yup.boolean().required('Required'),
    payment_option : Yup.number().required('Required').typeError(''),
    shipping_address : Yup.string().required('This field is required!'),
    billing_address : Yup.string().required('This field is required!'),
});

export default OrderSchema